module.exports = __webpack_public_path__ + "img/sk.6363e990.svg";